import { find } from 'lodash/fp';
import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import { useAppConfig } from '../context';
import {
  getBackgroundPath,
  RouteOverlayLocationState,
  useRouteOverlays,
} from '../route-overlays';
import { RouteModalParams } from './route-modals.types';

export function useRouteModals() {
  return useRouteOverlays();
}

export function useRouteModalConfig(routeModalId: string) {
  const { routes } = useAppConfig();

  const routeModalConfig = find({ id: routeModalId }, routes?.routeModals);

  if (!routeModalConfig) {
    throw new Error(`Modal with ID ${routeModalId} not found`);
  }

  return routeModalConfig;
}

export function useOpenRouteModal() {
  const { routes } = useAppConfig();
  const history = useHistory<RouteOverlayLocationState>();

  return useCallback(
    ({ modalId, pathParams = [], backgroundPath }: RouteModalParams) => {
      const route = find((route) => route.id === modalId, routes?.routeModals);

      if (!route) {
        console.error(`Modal with ID ${modalId} not found`);

        return;
      }

      const calculatedBackgroundPath =
        backgroundPath ||
        getBackgroundPath(history.location, route.backgroundPath);

      return history.push({
        pathname: route.generatePath(pathParams),
        state: {
          routeOverlay: {
            entityId: modalId,
            backgroundPath: calculatedBackgroundPath,
            path: route.path,
          },
        } as RouteOverlayLocationState,
      });
    },
    [routes?.routeModals, history]
  );
}
